import React from 'react';
import classNames from 'classnames';
import withExpandable from '@nerdwallet/react-with-expandable';

import { Box, Text } from '@nerdwallet/currency';

import './brand-header-expandable.less';

const BrandHeaderExpandable = ({ expanded, expandable, title, copy }) => {
  const bottomBorderStyle = expanded
    ? {
        borderBottom: '0px solid transparent',
        marginBottom: '0px',
      }
    : null;

  return (
    <Box>
      <Box className="brand-header__subnav" style={bottomBorderStyle}>
        <button
          {...expandable.toggle}
          type="button"
          className="brand-header__subnav--btn"
        >
          <Box className="brand-header__subnav--name">
            <Text>{title}</Text>
          </Box>
          {expanded ? `\u2013` : '+'}
        </button>
      </Box>
      <Box>
        <section
          {...expandable.region}
          className={classNames('expandable', {
            expanded,
            collapsed: !expanded,
          })}
        >
          {copy}
        </section>
      </Box>
    </Box>
  );
};

BrandHeaderExpandable.displayName = 'BrandHeaderExpandable';
BrandHeaderExpandable.propTypes = {
  ...withExpandable.propTypes,
};

export default withExpandable(BrandHeaderExpandable);
